import React, {useContext, useEffect, useRef, useState} from 'react';

import {AppContext} from '../../../AppModule/Context';

import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import ConnectToAgent from '../../../assets/svgComponents/ConnectToAgent';

import agentHandoffService from '../../../services/restServices/agentHandoffService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './handoffToAgentBtnComponent.css';

const HandoffToAgentBtnComponent = ({chatRoomDto = {}, widgetId = ''}) => {
  const context = useContext(AppContext);
  const isComponentMounted = useRef(true);

  const [isHandoffToAgentFlowRunning, setIsHandoffToAgentFlowRunning] =
    useState(false);

  useEffect(() => {
    isComponentMounted.current = true;
    return () => {
      isComponentMounted.current = false;
    };
  }, []);

  const onHandoffToAgent = async () => {
    setIsHandoffToAgentFlowRunning(true);

    const handoffToAgentResponse = await agentHandoffService.handoffToAgent(
      chatRoomDto.ownerObjectType,
      chatRoomDto.ownerObjectId,
      widgetId,
      chatRoomDto.roomId,
    );

    if (!isComponentMounted.current) return;

    if (!handoffToAgentResponse.success) {
      const toastTitle = utilsService.getApiErrMsg(
        VIDABOO_CONSTANTS.ERROR_CODE_TYPE.AGENT_HANDOFF,
        handoffToAgentResponse.code,
        'Failed to connect to an agent',
      );
      const toastObj = utilsService.getToastObj({
        toastTitle,
        toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
      });
      context.addToastObj(toastObj);
    }

    setIsHandoffToAgentFlowRunning(false);
  };

  return (
    <div className="et-hanoff-to-agent-container">
      <ButtonComponent
        showSpinner={isHandoffToAgentFlowRunning}
        isDisabled={isHandoffToAgentFlowRunning}
        type="other"
        image={
          <ConnectToAgent fillColor="var(--et-mentor-primary-text-color)" />
        }
        spinnerSize={VIDABOO_CONSTANTS.SPINNER_SIZE.SMALL}
        toolTipArrowStyle={{
          borderTopColor:
            'var(--et-mentor-cta-btn-primary-background-color-fc)',
        }}
        toolTipLabelStyle={{
          background: 'var(--et-mentor-cta-btn-primary-background-color)',
        }}
        toolTipTxt="Connect with human agent"
        onClick={onHandoffToAgent}
      />
    </div>
  );
};

export default HandoffToAgentBtnComponent;
